// src/features/providers/pages/ProvidersPage.tsx
import { ProviderTable } from '../components/ProviderTable';
import { ProviderActions } from '../components/ProviderActions';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle,
  DialogDescription 
} from '@/components/ui/dialog';
import { ProviderForm } from '../components/ProviderForm';
import { useProviderStore } from '@/stores/providerStore';

export function ProvidersPage() {
  const { isCreateModalOpen, closeCreateModal, selectedProvider } = useProviderStore();

  return (
    <div className="space-y-6">
      <ProviderActions />
      <ProviderTable />

      <Dialog open={isCreateModalOpen} onOpenChange={closeCreateModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {selectedProvider ? 'Edit Provider' : 'Create New Provider'}
            </DialogTitle>
            <DialogDescription>
              {selectedProvider 
                ? 'Update the provider details below.' 
                : 'Fill in the details to create a new provider.'}
            </DialogDescription>
          </DialogHeader>
          <ProviderForm />
        </DialogContent>
      </Dialog>
    </div>
  );
}